module.exports = __webpack_public_path__ + "static/media/onska.41e40579.mp3";